<h1>Login</h1>

<section id="login">
        
    <p class="login-input-wrapper">
        <label>User Name:</label>
        <mat-icon matSuffix>person</mat-icon>
        <input (keyup.enter)="checkPw()" [(ngModel)]="username">
    </p>

    <p class="login-input-wrapper">
        <label>Password:</label>
        <mat-icon matSuffix>password</mat-icon>
        <input (keyup.enter)="checkPw()" type="password" [(ngModel)]="password">
    </p>

    <p class="warning">{{message}}</p>

    <p>
        <button class="login-btn" (click)="checkPw()">
            <mat-icon>login</mat-icon>
            Login
        </button>
    </p>

    <p><a routerLink="/forgot-password">Forgot Password? </a></p>
    
</section>